/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_Create_SocialInputs */

const cs_templates_empty_cta_create_social = /** @type {(inputs: Templates_Empty_Cta_Create_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit sociální šablonu`)
};

const en_templates_empty_cta_create_social = /** @type {(inputs: Templates_Empty_Cta_Create_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create social template`)
};

/**
* | output |
* | --- |
* | "Create social template" |
*
* @param {Templates_Empty_Cta_Create_SocialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_create_social = /** @type {((inputs?: Templates_Empty_Cta_Create_SocialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_Create_SocialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_create_social(inputs)
	return cs_templates_empty_cta_create_social(inputs)
});